var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilament(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1906 21.5043H75.8086C77.8341 21.5043 79.476 19.8624 79.476 17.8371C79.476 15.8117 77.8341 14.1699 75.8086 14.1699H15.1906C13.1653 14.1699 11.5234 15.8118 11.5234 17.8371C11.5233 19.8624 13.1652 21.5043 15.1906 21.5043Z",
    fill: "#F1805E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1906 33.0072H75.8086C77.8341 33.0072 79.476 31.3653 79.476 29.34C79.476 27.3148 77.8341 25.6729 75.8086 25.6729H15.1906C13.1653 25.6729 11.5234 27.3148 11.5234 29.34C11.5234 31.3653 13.1652 33.0072 15.1906 33.0072Z",
    fill: "#F1805E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5234 40.8435C11.5234 42.8689 13.1653 44.5106 15.1906 44.5106H75.8088C77.8343 44.5106 79.4762 42.8687 79.4762 40.8435C79.4762 38.818 77.8343 37.1763 75.8088 37.1763H15.1908C13.1653 37.1761 11.5234 38.818 11.5234 40.8435Z",
    fill: "#F1805E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V5.33202H11.6656C11.5751 5.6507 11.5236 5.98573 11.5236 6.3332C11.5236 8.35866 13.1655 10.0004 15.1908 10.0004H75.8089C77.8344 10.0004 79.4763 8.35848 79.4763 6.3332C79.4763 5.98555 79.4247 5.65052 79.3343 5.33202H90.9998V0L0 0Z",
    fill: "#F1805E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4472 48.6797H15.1909C13.1655 48.6797 11.5236 50.3216 11.5236 52.3469C11.5236 52.6844 11.573 53.0096 11.6583 53.3201H0V58.6522H51.743C51.8385 58.979 51.8921 59.3238 51.8921 59.6814V87.3326C51.8921 89.3581 53.534 90.9998 55.5595 90.9998C57.5849 90.9998 59.2267 89.3579 59.2267 87.3326V58.459C59.2267 53.058 54.8482 48.6797 49.4472 48.6797Z",
    fill: "#F1805E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4677 52.3469C79.4677 50.3214 77.8258 48.6797 75.8003 48.6797H60.9453C63.1906 51.3176 64.5499 54.7317 64.5499 58.459V58.6522H90.9913V53.3201H79.333C79.4183 53.0098 79.4677 52.6844 79.4677 52.3469Z",
    fill: "#F1805E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilament);
export default __webpack_public_path__ + "static/media/filament.e374041e3b585efeeed7aac0559d3a53.svg";
export { ForwardRef as ReactComponent };